var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../layout.njk"] = require( "../layout.njk" );




var shim = require("D:/workspace/indivior-listmypractice-release/frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/views/pages/request-confirmation.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../layout.njk", true, "src/views/pages/request-confirmation.njk", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\r\n\r\n";
var t_4;
t_4 = true;
frame.set("showHCPHeader", t_4, true);
if(frame.topLevel) {
context.setVariable("showHCPHeader", t_4);
}
if(frame.topLevel) {
context.addExport("showHCPHeader", t_4);
}
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("meta_title"))(env, context, frame, runtime, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
output += t_5;
output += "\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("robots"))(env, context, frame, runtime, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
output += t_7;
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("body_class"))(env, context, frame, runtime, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
output += t_9;
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
output += t_11;
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_meta_title(env, context, frame, runtime, cb) {
var lineno = 4;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "Listing Request Received | List My Practice";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_robots(env, context, frame, runtime, cb) {
var lineno = 5;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "<meta name=\"robots\" content=\"noindex, nofollow\">";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_body_class(env, context, frame, runtime, cb) {
var lineno = 7;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "request-confirmation";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = 9;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\r\n    <main id=\"main-content\">\r\n        <section>\r\n            <div class=\"btn-back-wrapper\">\r\n                <a href=\"/listings\" class=\"btn-back\" >\r\n                    <svg class=\"svg--icon-carret\">\r\n                        <use xlink:href=\"#icon-carret\"></use>\r\n                    </svg>\r\n                    <span>Back to your listings</span>\r\n                </a>\r\n            </div>\r\n            <div class=\"container mb-40\">\r\n                <h1 class=\"mt-0\">Listing request received</h1>\r\n                <p>Your request has been received.</p>\r\n                <p>Requests for new listings by eligible healthcare providers will be added to the tool approximately 30 days after validation. Requests for changes to existing listings will be reviewed and updated within 2 to 3 business days.</p>\r\n                <a href=\"/listings\" class=\"btn btn-primary\">\r\n                    <span class=\"btn-content\">View Your Listings</span></a>\r\n            </div>\r\n        </section>\r\n    </main>\r\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_meta_title: b_meta_title,
b_robots: b_robots,
b_body_class: b_body_class,
b_content: b_content,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/views/pages/request-confirmation.njk"] , dependencies)